import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ComoCreateAccountModalConfig } from '@front-platform/content-builder';
import { comoCreateAccountModalResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { ModalsService } from 'src/app/core/services/modals/modals.service';

import { ModalScrollBlockBase } from '@core/base/modalScrollBlock/modal-scroll-block.base';
import { ComoCreateOrLinkAccountModalComponent } from '@shared/modals/como/como-create-or-link-account-modal/como-create-or-link-account-modal.component';
export interface ComoCreateAccountModalRuntimeConfig {}

export type ComoCreateAccountModalConfigInput = Partial<
  Omit<ComoCreateAccountModalConfig, keyof ComoCreateAccountModalRuntimeConfig> &
    ComoCreateAccountModalRuntimeConfig
>;
export type ComoCreateAccountModalResolvedConfig = Omit<
  ComoCreateAccountModalConfig,
  keyof ComoCreateAccountModalRuntimeConfig
> &
  Partial<ComoCreateAccountModalRuntimeConfig>;
export interface ComoCreateAccountModalContract extends ConfigComponentContract<
  ComoCreateAccountModalConfigInput,
  ComoCreateAccountModalResolvedConfig
> {}

@Component({
  selector: 'app-como-create-account-modal',
  templateUrl: './como-create-account-modal.component.html',
  standalone: false,
})
export class ComoCreateAccountModalComponent
  extends ModalScrollBlockBase
  implements OnInit, ComoCreateAccountModalContract
{
  readonly config = input<ComoCreateAccountModalConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ComoCreateAccountModalConfig,
    ComoCreateAccountModalRuntimeConfig
  >(comoCreateAccountModalResolveConfig, () => ({ config: this.config() }));
  static handle = 'como-create-account-modal';

  constructor(private readonly modalsService: ModalsService) {
    super();
  }

  ngOnInit(): void {
    this.modalsService.open(ComoCreateOrLinkAccountModalComponent.handle);
    this.modalsService.close(ComoCreateAccountModalComponent.handle);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ComoCreateAccountModalComponent, {
  'keyAliases': {},
});
